import { TextField } from "@mui/material"
import Proptypes from "prop-types";

export const ModalText = ({elementRef, value, setValue}) => {

    return (
        <>
            <TextField
                ref={elementRef}
                onChange={({target}) => setValue(target.value)}
                required
                type="text"
                name="text"
                margin="normal"
                fullWidth
                color="primary"
                placeholder="Texto"
                defaultValue={value}
            />
            <br />
        </>
    )
}

ModalText.propTypes = {
    elementRef: Proptypes.object,
    value: Proptypes.string,
    setValue: Proptypes.func,
}